import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';

import { secondaryMono1 } from 'Styles/theme';

export const cardWidth = 345;

export const useStyles = makeStyles(theme => ({
	cardRoot: {
		display: 'flex',
		background: grey[100],
		borderRadius: 8,
		height: '100%',
		maxHeight: 124,
		minWidth: cardWidth,
		[theme.breakpoints.down('md')]: {
			width: 300,
			minWidth: 300
		}
	},
	cardContent: {
		display: 'flex',
		padding: '16px 16px 16px 32px',
		[theme.breakpoints.down('md')]: {
			padding: '16px 16px 16px 24px'
		},
		'&:last-child': {
			paddingBottom: 16 // This is to overwrite mui behaviour
		},
		flex: 1
	},
	contactName: {
		fontWeight: 500,
		fontSize: 16,
		lineHeight: '22px',
		color: 'black',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	jobTitle: {
		fontWeight: 400,
		fontSize: 14,
		lineHeight: '22px',
		textTransform: 'uppercase',
		color: secondaryMono1
	},
	email: {
		marginTop: 4,
		fontWeight: 400,
		fontSize: 14,
		lineHeight: '22px',
		color: secondaryMono1,
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	phone: {
		fontWeight: 400,
		fontSize: 14,
		lineHeight: '22px',
		color: secondaryMono1,
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	contactData: {
		flex: 1,
		[theme.breakpoints.down('md')]: {
			maxWidth: 170
		},
		padding: '0 5px',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	contactButtons: {
		marginLeft: 'auto',
		display: 'flex',
		flexDirection: 'row',
		'& > a:not(:last-child)': {
			marginRight: 4
		}
	},
	contactBtnRoot: {
		height: 42,
		width: 42,
		minWidth: 40,
		background: 'none',
		'&:hover': {
			background: 'none'
		},
		border: `1px solid rgba(0, 0, 0, 0.26)`,
		borderRadius: 4,
		color: secondaryMono1
	},
	contactBtnLabel: {
		fontSize: 12
	}
}));
